import axios from "axios";
import * as routes from './_routes';
import {TokenStorage} from './tokenStorage';

export function loginCheck(username, password) {
    return axios.post(routes.LOGIN_CHECK_URL, {
        username,
        password
    });
}

export function checkTwoFactorCode(uuid, code) {
    return axios.post(routes.LOGIN_URL, {
        code,
        uuid
    }, {withCredentials: true});
}

export function requestPassword(email) {
    return axios.post(routes.REQUEST_PASSWORD_URL, {email});
}

export function logout() {
    return axios.get(routes.LOGOUT_URL, {
        withCredentials: true,
        headers: {'Authorization': `Bearer ${TokenStorage.getToken()}`}
    });
}
